import { UpdateResponse } from './address-form.model';
import { debounce } from '../../100-components/helper';
import {lockForm, unlockForm} from "../../100-components/form-fields/form-fields";

const ATTRIBUTE_CITY_WRAPPER = 'data-klt-p-row-city';
const ATTRIBUTE_ZIP_WRAPPER = 'data-klt-p-row-zip';
const ATTRIBUTE_ADDRESS_FORM_CITY_UPDATE = 'data-p-address-form-city-update';

const CLASS_CITY_SINGLE = 'klt-c-form-row--city-single';
const CLASS_CITY_MULTIPLE = 'klt-c-form-row--city-multiple';

let updateEndpoint: string;
let addressForm: {
    formElement: HTMLFormElement;
    citySelectElement: HTMLSelectElement;
    cityInputElement: HTMLInputElement;
    zipWrapperElement: HTMLElement;
    zipInputElement: HTMLInputElement;
    cityWrapperElement: HTMLElement;
} = {
    formElement: null,
    citySelectElement: null,
    cityInputElement: null,
    zipWrapperElement: null,
    zipInputElement: null,
    cityWrapperElement: null
};

export default function init() {
    addressForm.formElement = document.querySelector(`[${ATTRIBUTE_ADDRESS_FORM_CITY_UPDATE}]`) as HTMLFormElement;

    if (!addressForm.formElement) {
        return;
    }

    updateEndpoint = addressForm.formElement.getAttribute(`${ATTRIBUTE_ADDRESS_FORM_CITY_UPDATE}`);
    addressForm.zipWrapperElement = document.querySelector(`[${ATTRIBUTE_ZIP_WRAPPER}]`) as HTMLElement;
    addressForm.cityWrapperElement = document.querySelector(`[${ATTRIBUTE_CITY_WRAPPER}]`) as HTMLElement;

    if (addressForm.zipWrapperElement && addressForm.cityWrapperElement && updateEndpoint) {
        addressForm.zipInputElement = addressForm.zipWrapperElement.querySelector('input') as HTMLInputElement;
        addressForm.cityInputElement = addressForm.cityWrapperElement.querySelector('input') as HTMLInputElement;
        addressForm.citySelectElement = addressForm.cityWrapperElement.querySelector('select') as HTMLSelectElement;

        if (!addressForm.zipInputElement || !addressForm.cityInputElement || !addressForm.citySelectElement) {
            return;
        }

        if (
            addressForm.zipInputElement.hasAttribute('readonly') &&
            (addressForm.zipInputElement.getAttribute('readonly') === 'true' ||
                addressForm.zipInputElement.getAttribute('readonly') === 'readonly')
        ) {
            return;
        }

        addressForm.zipInputElement.addEventListener('change', function() {
            onZipInputChange(this);
        });

        addressForm.zipInputElement.addEventListener(
            'keyup',
            debounce(function() {
                onZipInputChange(this);
            }, 600)
        );
    }
}

function onZipInputChange(element?: HTMLInputElement) {
    element = element || this;
    const postcode = element.value;

    if (element)
        if (!postcode || postcode.length < 4) {
            clearCityList();
            setSingleValueToDefault();
            return;
        }

    lockForm(addressForm.formElement);

    updateCity(postcode)
        .then(response => {
            const data = response as UpdateResponse;
            clearCityList();

            if (data.length > 1) {
                for (let city of data) {
                    const opt = document.createElement('option');
                    opt.value = city.name;
                    opt.text = city.name;
                    addressForm.citySelectElement.add(opt, null);
                }

                showSelect();
            } else if (data.length === 1) {
                addressForm.cityInputElement.value = data[0].name;
                showSingleValue();
            }

            unlockForm(addressForm.formElement);
        })
        .catch(error => {
            console.error(error.message);
            unlockForm(addressForm.formElement);
        });
}

function showSelect() {
    const isActive = document.activeElement === addressForm.cityInputElement;
    addressForm.cityWrapperElement.classList.add(`${CLASS_CITY_MULTIPLE}`);
    addressForm.cityWrapperElement.classList.remove(`${CLASS_CITY_SINGLE}`);
    addressForm.cityInputElement.setAttribute('disabled', '');
    addressForm.citySelectElement.removeAttribute('disabled');

    if (isActive) {
        addressForm.citySelectElement.focus();
    }
}

function showSingleValue() {
    const isActive = document.activeElement === addressForm.citySelectElement;
    addressForm.cityWrapperElement.classList.remove(`${CLASS_CITY_MULTIPLE}`);
    addressForm.cityWrapperElement.classList.add(`${CLASS_CITY_SINGLE}`);
    addressForm.cityInputElement.removeAttribute('disabled');
    addressForm.citySelectElement.setAttribute('disabled', '');

    if (isActive) {
        addressForm.cityInputElement.focus();
    }
}

function setSingleValueToDefault() {
    showSingleValue();
    addressForm.cityInputElement.value = '–';
}

function clearCityList() {
    if (!addressForm.citySelectElement) {
        return;
    }

    for (let i = addressForm.citySelectElement.options.length - 1; i >= 0; i--) {
        addressForm.citySelectElement.remove(i);
    }
}

/**
 * Call the API for updating the cart
 * @param url
 * @returns {Promise<any>}
 */
async function updateCity(zip) {
    if (!updateEndpoint || !zip) {
        return;
    }

    const url = `${updateEndpoint}?zip=${zip}`;
    const response = await fetch(url, { credentials: 'include' });

    const data = await response.json();
    return data;
}
